import React from 'react';

const SvgAe = props => (
  <svg width={props.width || 64} height={props.height || 64} {...props}>
    <path
      fillRule="evenodd"
      d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zM9.752 11c-2.473.174-4.591 2.228-4.752 4.621v.785c.17 2.398 2.317 4.428 4.787 4.594h.803c1.96-.172 3.608-1.415 4.796-2.862-.29-.425-.583-.849-.884-1.266-.764 1.128-1.76 2.192-3.102 2.66-1.208.438-2.61.157-3.615-.596-1.342-.95-1.83-2.793-1.23-4.279.682-1.804 2.97-2.866 4.843-2.187 1.515.551 2.45 1.915 3.366 3.128 1.064 1.372 1.944 2.913 3.315 4.036.944.802 2.156 1.266 3.403 1.366h.746c2.026-.18 3.879-1.534 4.515-3.417a60.387 60.387 0 0 0-1.389.006c-.908 1.854-3.493 2.751-5.341 1.654-2.557-1.517-3.661-4.394-5.67-6.432-.968-.99-2.274-1.677-3.687-1.811h-.904zm11.68 0c-1.974.183-3.61 1.453-4.783 2.921.275.407.559.809.845 1.207.743-1.075 1.707-2.081 2.987-2.54 1.606-.61 3.615-.035 4.565 1.37.39.538.54 1.189.654 1.825-1.624.01-3.247 0-4.873.004.002.36.002.717 0 1.077 2.057-.002 4.116.01 6.173-.009v-1.23c-.205-2.397-2.325-4.468-4.818-4.625h-.75z"
    />
  </svg>
);

export default SvgAe;



// WEBPACK FOOTER //
// ./src/components/Common/Icons/black/ae.js